export const addUpdateRequest = ({ commit }) => {
  commit('INCREMENT_UPDATE_REQUESTS')
}
